<template>
    <div>
        <modal
            name="stater-exam-popup"
            transition="nice-modal-fade"
            width="680"
            height="504"
        >
            <div class="common-popup-modal">
                <div class="popup__head">
                    <p>你需要参加能力测试</p>
                    <p>达到分数线后才能报名{{res.title_grade}}{{res.subject_full_name}}{{res.difficulty_level}}星难度班</p>
                    <i class="icon iconfont icon-guanbi" @click="$modal.hide('stater-exam-popup')"></i>
                </div>
                <div class="popup__body">
                    <vue-qr :logo-src="imageUrl" :text="url" :margin="0" :size="200" class="qrcode" />
                    <div class="modal__text">请使用微信扫码，参加考试</div>
                </div>
            </div>
        </modal>
        <modal
            name="point-popup"
            transition="nice-modal-fade"
            width="680"
            height="504"
            @before-close="beforeClose"
        >
            <div class="common-popup-modal">
                <div class="popup__head">
                    提示
                    <i class="icon iconfont icon-guanbi" @click="$modal.hide('point-popup')"></i>
                </div>
                <div class="popup__body">
                    <div class="modal__text">{{suggestion}}</div>
                    <div class="modal-btn" @click="$modal.hide('point-popup')">我知道了</div>
                </div>
            </div>
        </modal>
    </div>
</template>

<script>
import icon from '@business/assets/img/gaotu-icon.png';
import config from '~/environment';

export default {
    props: {
        data: {
            type: Object,
            default() {
                return {};
            }
        },
        res: {
            type: Object,
            default() {
                return {};
            }
        }
    },
    data() {
        return {
            url: '',
            suggestion: '',
            examData: {},
            imageUrl: icon
        };
    },
    mounted() {
        const {examNumber, hasExamChance, clazzSuggestion} = this.data;
        this.suggestion = clazzSuggestion;
        this.url = `https:${config.env.mUrl}/exam/examExplanation?examNumber=${examNumber}&fromLink=1`;
        if (hasExamChance) {
            this.$modal.show('stater-exam-popup');
        }
        else {
            this.$modal.show('point-popup');
        }
    },
    methods: {
        beforeClose() {
            this.$parent.setExamdData();
        }
    }
};

</script>
<style lang="less" scoped>
.qrcode {
    position: relative;
    left: 50%;
    margin-left: -100px;
}
</style>
